// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1781":"3b53517f","4830":"67d63c14"}[chunkId] + ".chunk.css";
};